import type {Warning} from './layout'

export function formatWarning(w: Warning): string {
    switch (w.kind) {
        case 'diagonal-above-max-band':
            return `Diagonāle ${Math.round(w.diagonal)} mm pārsniedz tabulas augšējo robežu`
        case 'empty-rows':
            return 'Nav rindu'
        case 'h-out-of-spec':
            return `Rinda ${w.rowIndex + 1}: h=${w.h} ārpus 100–400 mm`
        case 'h-not-on-step':
            return `Rinda ${w.rowIndex + 1}: h=${w.h} nav solim 50 mm atbilstošs`
        case 'non-convergent':
            return `Iterācijas neapstājās pēc ${w.iterations} soļiem`
    }
}
